import { Stack, StackProps } from '@mui/system';
import { Types } from '@scorenco/core';

import {
  CompetitionRankingColumnDefault,
  CompetitionRankingColumnGnp,
  CompetitionRankingColumnGp,
  CompetitionRankingColumnSerie,
} from './columns';
import { useCompetitionRankingContext } from './CompetitionRankingContext';

export type CompetitionRankingRowProps = StackProps & {
  ranking?: Types.Competitions_Ranking_Detail;
};

export const CompetitionRankingInfo = ({
  ranking,
  ...rest
}: CompetitionRankingRowProps) => {
  const { columns, highlightTeams } = useCompetitionRankingContext();
  const isHighlight =
    ranking?.team_in_season_id &&
    highlightTeams?.includes(ranking.team_in_season_id);

  return (
    <Stack
      sx={{
        minHeight: '3rem',
        fontSize: '0.85rem',
        letterSpacing: '-0.05em',
        textAlign: 'center',
        alignItems: 'center',
      }}
      direction="row"
      {...rest}
    >
      {columns.map((col) => {
        if (col === 'pts') {
          return (
            <CompetitionRankingColumnDefault
              className="cell"
              key={col}
              value={ranking?.[col as keyof typeof ranking]}
              sx={{
                fontWeight: isHighlight ? 'bold' : 'normal',
                backgroundColor: 'background.default',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            />
          );
        }
        if (col === 'gnp') {
          return (
            <CompetitionRankingColumnGnp
              className="cell"
              key={col}
              ranking={ranking}
              sx={{
                fontWeight: isHighlight ? 'bold' : 'normal',
              }}
            />
          );
        }

        if (col === 'gp') {
          return (
            <CompetitionRankingColumnGp
              className="cell"
              key={col}
              ranking={ranking}
              sx={{
                fontWeight: isHighlight ? 'bold' : 'normal',
              }}
            />
          );
        }

        if (col === 'serie') {
          return (
            <CompetitionRankingColumnSerie
              className="cell"
              key={col}
              ranking={ranking}
            />
          );
        }

        return (
          <CompetitionRankingColumnDefault
            className="cell"
            key={col}
            value={ranking?.[col as keyof typeof ranking]}
            sx={{
              fontWeight: isHighlight ? 'bold' : 'normal',
            }}
          />
        );
      })}
    </Stack>
  );
};
